<template>
<div class="container-fluid">
	<page-loading v-if="!data_loaded" />

	<div v-else class="row">
		<div class="col-12">
			<div class="campaign card fill-app-height without-page-title d-flex" :class="[config.layout === 'desktop' ? 'flex-row' : 'flex-column', config.layout]">
				
				<div class="campaign-details filled-box-brand-secondary drop-down-hover" :class="config.layout">

					<div v-if="!editing" class="d-flex filled-box-header px-35 py-25">
						<span class="flex-grow-1 text-uppercase font-weight-bold" @click="toggleCampaignDetails()" style="cursor: pointer">
							{{ campaign.title }}
							<i class="fas" :class="showCampaignDetails == false ? 'fa-caret-right' : 'fa-caret-down'"></i>
						</span>								

						<div v-if="campaign.can.update" class="drop-down">
							<a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<i class="far fa-ellipsis-h text-white text-lg" style="font-size:1.125rem"></i>
							</a>
							<div class="dropdown-menu dropdown-menu-right py-0" aria-labelledby="dropdownMenuLink">
								<a class="dropdown-item" href="#" v-on:click.stop="setEditing(true)" data-test="editCampaign">Edit Campaign</a>
							</div>
						</div>
					</div>

					<div v-else class="filled-box-header px-35 py-25">
						<div class="text-uppercase font-weight-bold w-100">Campaign Title</div>
						<input class="form-control form-control-sm" v-model="form.title" data-test="editCampaignTitle">
					</div>

					<template v-if="showCampaignDetails">
						<div class="d-flex px-35 py-25">
							<div class="flex-fill" v-if="campaign.assigned_user" :class="{ 'w-60 mr-1' : editing }">
								<div class="text-uppercase font-weight-bold">Assigned</div>
								<div v-if="!editing" class="d-flex align-items-center">
									<div class="rounded-circle circle-cropped avatar-xs mr-1"><img :src="campaign.assigned_user.photo_url" class="img-fluid"></div>
									<span class="text-white">{{ campaign.assigned_user.display_name }}</span>
								</div>
								<v-select
									v-else 			                            
									label="display_name"
									:options="options.user_ids"
									:reduce="display_name => display_name.id"
									v-model="form.assigned_user_id"
									:clearable="false"
								/>	
							</div>

							<div class="flex-fill text-right" :class="{ 'w-40' : editing }">
								<div class="text-uppercase font-weight-bold">Complete by</div>
								<span v-if="!editing" class="text-white">{{ campaign.complete_by ? campaign.complete_by : '--' }}</span>
								<date-picker v-else 
									readonly="true"
									v-model="form.complete_by"
									:config="config.datePickerOptions"
									class="form-control-sm"
									data-test="editCampaignEndDate" />
							</div>
						</div>

						<div class="px-35">
							<div class="section-divider"></div>
						</div>


						<div v-if="!editing" class="px-35 py-25">
							<div class="d-flex">
								<div class="flex-fill">
									<div class="text-uppercase font-weight-bold">Campaign Type</i></div>
									<span class="text-white text-lg text-transform-none">{{ campaign.type_readable }}</span>				
								</div>
								<div class="flex-fill">
									<div class="text-uppercase font-weight-bold">Visits<i v-if="campaign.can.update" @click="toggleAddVisits()" class="fal fa-plus-circle ml-1 text-xl" v-tooltip.bottom="'Add Visits'" data-test="toggleAddStops"></i></div>
									<span class="text-white text-lg text-transform-none" data-test="plannedVisitCount">{{ campaign.visits.length }}</span>				
								</div>
							</div>

							<div v-show="showAddVisits" class="w-100 text-right pt-25">
								<v-select
									multiple
									label="display_name"
									:options="nonCampaignPhysicians"
									v-model="added_visits"
									data-test="addPhysician" />
								<span class="btn btn-sm btn-ghost text-transform-none mt-2" @click="toggleAddVisits()">Cancel</span>
								<span class="btn btn-sm btn-outline-secondary text-transform-none mt-2 text-right" @click="addCampaignVisit()" data-test="saveAddedStops">Add to Campaign</span>
							</div>
						</div>

						<div v-else class="px-35 py-25">
							<div class="text-uppercase font-weight-bold">Campaign Type</i></div>
							<v-select
								label="label" 			                            
								:options="[
									{ label: 'Mailer', value: 'mail'},
									{ label: 'Email', value: 'email'},
									{ label: 'Event/Meeting', value: 'event'},
									{ label: 'Phone', value: 'phone'},
									{ label: 'Fax', value: 'fax'},
								]"
								:reduce="label => label.value"
								v-model="form.type"
								:clearable="false"
								data-test="editCampaignType"
							/>
						</div>

						<div class="px-35">
							<div class="section-divider"></div>
						</div>


						<template v-if="!editing">
							<div class="d-flex px-35 pt-25 pb-1">
								<div class="flex-fill text-uppercase font-weight-bold" @click="toggleTimestamps()" style="cursor: pointer;">
									Status <i class="fas" :class="showTimestamps == false ? 'fa-caret-right' : 'fa-caret-down'"></i>
								</div>
								<div class="flex-fill text-right text-white" data-test="campaignStatus">
									{{ campaign.status_text }} ({{ campaignProgress }}%)
								</div>
							</div>

							<div class="px-35 pb-3">
								<div class="progress" style="height:4px">
									<div class="progress-bar bg-white" role="progressbar" :style="'width: ' + campaignProgress + '%;'"></div>
								</div>
							</div>

							<template v-if="showTimestamps">
								<div class="d-flex px-35 pb-2">
									<div class="flex-fill">
										<div class="text-uppercase font-weight-bold">Started On</div>
										<span class="text-white">{{ campaign.started_on ? moment(campaign.started_on).format("MMM D, YYYY") : '--' }}</span>
									</div>
									<div class="flex-fill text-right">
										<div class="text-uppercase font-weight-bold">Completed On</div>
										<span class="text-white">{{ campaign.ended_on ? moment(campaign.ended_on).format("MMM D, YYYY") : '--' }}</span>
									</div>
								</div>
							</template>
						</template>

						<div v-else class="px-35 pt-25 pb-2">
							<div class="text-uppercase font-weight-bold">Status</div>
							<v-select
								v-if="editing" 			                            
								:options="[
									{ label:'New (not started)', value:0 },
									{ label:'In progress', value:1 },
									{ label:'Complete', value:2 },
									{ label:'Archived', value:3 },
								]"
								:reduce="label => label.value"
								v-model="form.status"
								:clearable="false"
							/>
						</div>


						<div class="px-35">
							<div class="section-divider"></div>
						</div>


						<div class="px-35 py-25">
							<div class="text-uppercase font-weight-bold">Description</div>
							<div v-if="!editing" class="text-white text-transform-none" v-html="campaign.description" />
				            <vue-editor 
				            	v-else
				                :editor-toolbar="config.editor.toolbar"
				                v-model="form.description"
				            />
						</div>


						<div v-if="editing" class="px-35 pb-25 text-right w-100">
							<span class="btn btn-sm btn-secondary" @click="setEditing(false)">Cancel</span>
							<span class="btn btn-sm btn-primary" @click="updateCampaign()" data-test="saveEditCampaignButton">Save Campaign</span>
						</div>

					</template>
				</div>



				<div class="campaign-visits flex-grow-1 d-flex flex-column">
					<div class="flex-grow-1" style="overflow-y: auto">
					<table class="table leading-tight">
						<thead>
							<th style="width:1%;"><input type="checkbox" v-model="selectAll" @click="select" data-test="selectAllStops"></th>
							<th style="width:2%;"></i></th>
							<th>Name</th>
							<th v-if="campaign.type === 'email'" colspan=2>Email</th>
							<th v-if="campaign.type === 'phone'" colspan=2>Phone</th>
							<th v-if="campaign.type === 'fax'" colspan=2>Fax</th>
							<th v-if="campaign.type === 'event' || campaign.type === 'mail'" colspan=5>Address</th>
						</thead>
						<tbody>
							<template v-for="visit in campaign.visits">
								<tr class="campaign-visit" :class="visit.checkin_id ? 'visited' : 'unvisited'" data-test="campaignStop">
									<td>
										<input type="checkbox"
											v-model="bulk_action_ids"
											:value="{ morphable_id: visit.visitable_id, morphable_type: visit.visitable_type }"
											data-test="selectCampaignStop">
									</td>
									<td 
										@click="visit.checkin_id ? showCheckin(visit.checkin_id) : buildCheckinModal(visit.visitable)"
										data-toggle="modal" :data-target="visit.checkin_id ? '#checkinModal' : '#myModal'"
										class="pt-25 leading-normal" :class="config.layout === 'mobile' ? 'px-1' : ''"
									>
										<div class="campaign-icon text-center" :class="visit.checkin_id ? 'inactive' : ''">
											<i v-if="visit.checkin_id" class="fas fa-check route-icon-label" data-test="showCampaignCheckin"></i>
											<i v-else class="fas fa-plus route-icon-label" data-test="addCampaignCheckin"></i>
										</div>
									</td>
									<td
										@click="visit.checkin_id ? showCheckin(visit.checkin_id) : buildCheckinModal(visit.visitable)"
										data-toggle="modal" :data-target="visit.checkin_id ? '#checkinModal' : '#myModal'"
										class="font-weight-bold"
										data-test="campaignStopName"
									>{{ visit.visitable.display_name }}</td>

									<template v-if="campaign.type === 'email'">
										<td><a :href="'mailto:' + visit.visitable.email">{{ visit.visitable.email }}</a></td>
									</template>

									<template v-if="campaign.type === 'phone'">
										<td><a v-if="visit.visitable.location_primary" :href="'tel:' + visit.visitable.location_primary.phone">{{ visit.visitable.location_primary.phone }}</a></td>
									</template>

									<template v-if="campaign.type === 'fax'">
										<td><a v-if="visit.visitable.location_primary" :href="'tel:' + visit.visitable.location_primary.fax">{{ visit.visitable.location_primary.fax }}</a></td>
									</template>

									<template v-if="campaign.type === 'event' || campaign.type === 'mail'">
										<td><template v-if="visit.visitable.location_primary">{{ visit.visitable.location_primary.address }}</template></td>
										<td><template v-if="visit.visitable.location_primary">{{ visit.visitable.location_primary.city }}</template></td>
										<td><template v-if="visit.visitable.location_primary">{{ visit.visitable.location_primary.state }}</template></td>
										<td><template v-if="visit.visitable.location_primary">{{ visit.visitable.location_primary.zip }}</template></td>
									</template>

									<td class="drop-down dropleft drop-down-show leading-normal">							        
							            <a v-if="campaign.can.update" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							            	<i class="far fa-ellipsis-h text-xl"></i>
							            </a>
							            <div class="dropdown-menu py-0" aria-labelledby="dropdownMenuLink">
											<span
												v-if="visit.checkin_id"
												@click="showCheckin(visit.checkin_id)"
												v-on:click.prevent
												class="dropdown-item" data-toggle="modal" data-target="#checkinModal"
												data-test="menuShowCampaignCheckin">View Check-in
											</span>
											
											<span
												v-else
												@click="buildCheckinModal(visit.visitable)"
												class="dropdown-item" data-toggle="modal" data-target="#myModal"
												data-test="menuAddCampaignCheckin">Create Check-in
											</span>

											<router-link
												v-if="visit.visitable_type == 'App\\Group'"
												:to="{ name: 'groups.show', params: { id: visit.visitable.id } }"
												class="dropdown-item">View Group
											</router-link>
											<router-link
												v-if="visit.visitable_type == 'App\\Physician'"
												:to="{ name: 'physicians.show', params: { id: visit.visitable.id } }"
												class="dropdown-item">View Physician
											</router-link>

											<span
												v-if="!visit.checkin_id"
												@click="deleteCampaignVisit(visit.id)"
												class="dropdown-item"
												data-test="menuDeleteCampaignStop">Remove from Campaign</span>
							            </div>
									</td>									
								</tr>
							</template>
						</tbody>
					</table>
					</div>

					<div v-if="config.layout === 'desktop'" class="actions px-35 py-25">
						<button
							@click="exportCampaignVisits()"
							class="btn btn-primary"
							:class="bulk_action_ids.length > 1 ? 'btn-primary' : 'btn-light'"
							:disabled="bulk_action_ids.length < 2">
							Export Records to CSV
						</button>
						<button 
							v-if="campaign.can.update"
							@click="buildCheckinModal(bulk_action_ids)"
							class="btn btn-primary"
							:class="bulk_action_ids.length > 1 ? 'btn-primary' : 'btn-light'"
							:disabled="bulk_action_ids.length < 2"
							data-toggle="modal" data-target="#myModal"
							data-test="saveBulkCheckins">
							Bulk save check-ins
						</button>
					</div>
				</div>


				<div v-if="config.layout === 'mobile'" class="actions px-25 py-25">
					<button
						@click="exportCampaignVisits()"
						class="btn btn-primary"
						:class="bulk_action_ids.length > 1 ? 'btn-primary' : 'btn-light'"
						:disabled="bulk_action_ids.length < 2">
						Export CSV
					</button>
					<button 
						v-if="campaign.can.update"
						@click="buildCheckinModal(bulk_action_ids)"
						class="btn btn-primary"
						:class="bulk_action_ids.length > 1 ? 'btn-primary' : 'btn-light'"
						:disabled="bulk_action_ids.length < 2"
						data-toggle="modal" data-target="#myModal">
						Bulk save check-ins
					</button>
				</div>

			</div>
		</div>

		<checkin-view-modal :showing_checkin="showing_checkin" />

	</div>
</div>
</template>



<script>

	import { mapGetters, mapState } from 'vuex';
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';
	import CheckinViewModal from '../../components/CheckinViewModal';

  	export default {  		
  		mixins: [BreadcrumbsManager],

		components: {
            CheckinViewModal,
        },

		props: {
			id: {
				type: Number,
				required: true,
			},
		},

		data () {
			return {
				data_loaded: false,

				campaign: {},

				checkin_added: null, //use to prevent the progress watcher from firing completion
	        	checkin_options: {
	        		campaign_id: this.id,
	        		bulk_save: false,
	        		checkinables: null,
	        	},

				showCampaignDetails: false,
				showAddVisits: false,
				added_visits: [],

				showTimestamps: false,

	        	showing_checkin: { //declare arrays so vue doesn't complain
					checkin_type: [], 
					checkin_user: [],
					checkinable: [],
					service_lines: [],
				},

				selectAll: false,
				bulk_action_ids: [],

	        	editing: false,

				form: {},
			}
		},

		created() {
			this.fetchCampaign();
			this.setLayout();
		},

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Campaigns', to: { name: 'campaigns.index' } },
                { text: '[Campaign Name]', to: { name: 'campaigns.show' } }
            ]); 
        },

		mounted() {
			this.$root.$on('campaign_visits_changed', data => {
				this.campaign.visits = data.visits;
			});

			this.$root.$on('checkinadded', data => {

				data.forEach(newCheckin => {
					//push the new checkin_id into the appropriate visit
					var campaign_visit_index = this.campaign.visits.findIndex((element) => {
	                    return element.id === newCheckin.campaign_visit.id;
	                });				

					this.campaign.visits[campaign_visit_index].checkin_id = newCheckin.id;
				    this.campaign.visits[campaign_visit_index].checkin = newCheckin;
				});
				
				this.checkin_added = true;
				//on first checkin of any kind, set the status and starting time for the front end. Back end does via listeners.
				if (this.campaign.status === 0) {
					this.mockCampaignStarted();
				}
			});

			this.$root.$on('checkin_updated', data => {
		    	this.campaign.checkins.splice(this.checkinIndex(data.id), 1); //remove
		    	this.campaign.checkins.push(data); //re-add
		    	this.$root.$emit('show_checkin', data.id);//and re-load modal
  		    });

		    //find the checkin in the array and move it so it can be in props
		    this.$root.$on('show_checkin', id => { 
		    	var show_checkin = this.checkins.find(checkins => { 
					return checkins.id === id;
				});
		    	this.showing_checkin = show_checkin;
		    });

		},

		methods: {
			addCampaignVisit() {
				axios.post(`/api/campaign-visits`, { 
					campaign_id: this.campaign.id,
					added_visits: this.added_visits,
				})
				.then(({ data }) => { //returns the campaign visits
                    this.$root.$emit('campaign_visits_changed', data);
                    this.added_visits = [];
                });
			},

			buildCheckinModal(visitable) {
				if (visitable.length > 1) {
					this.checkin_options.bulk_save = true;
					this.checkin_options.checkinables = this.bulk_action_ids.filter(newCheckinable => 
						!(this.checkins.some(checkin => checkin.checkinable_id == newCheckinable.morphable_id) &&
						this.checkins.some(checkin => checkin.checkinable_type == newCheckinable.morphable_type))
					);
				} else {
					this.checkin_options.bulk_save = false;
					this.checkin_options.checkinables = { 
						morphable_id : visitable.id, 
						morphable_type : visitable.model,
						display_name : visitable.display_name
					};
				}

				this.$root.$emit('build_checkin_modal', { checkin_options: this.checkin_options });
			},

			checkinIndex(checkinId) {
                return this.campaign.checkins.findIndex((element) => {
                    return element.id === checkinId;
                });
            },

			deleteCampaignVisit(id) {
				axios.delete('/api/campaign-visits/' + id).then(({ data }) => { //returns the campaign visits
                    this.$root.$emit('campaign_visits_changed', data);
					Swal.fire({
	                    toast: true,
	                    position: 'top-end',
	                    showConfirmButton: false,
	                    timer: 3000,
	                    icon: 'success',
	                    title: 'Visit deleted.',
	                });
					if (this.campaignProgress == 100 && this.campaign.status < 2) {
						this.mockCampaignCompleted();						
					}                 
                });								
			},

			exportCampaignVisits() {
				axios.post('/api/campaigns/export', this.bulk_action_ids ).then((response) => {
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', 'file.csv'); //or any other extension
					document.body.appendChild(link);
					link.click();

					Swal.fire({
	                    toast: true,
	                    position: 'top-end',
	                    showConfirmButton: false,
	                    timer: 3000,
	                    icon: 'success',
	                    title: 'Export complete!',
	                });	
				});
			},

			fetchCampaign() {
	            axios.get(`/api/campaigns/${this.id}`).then(({data}) => {
                    this.campaign = data;
                    this.data_loaded = true;

                    this.replaceBreadcrumb({
                        find: '[Campaign Name]',
                        replace: { text: this.campaign.title }
                    });                       
	        	});	   
			},

            select() {
				this.bulk_action_ids = [];
				if (!this.selectAll) {
					this.campaign.visits.forEach(visit => {
						this.bulk_action_ids.push({ morphable_id: visit.visitable_id, morphable_type: visit.visitable_type })
					});
				}
			},

			setEditing(value) {
				this.editing = value;
				if (value == true) {
					this.showCampaignDetails = true;
					this.form = {
						title: this.campaign.title,
						assigned_user_id: this.campaign.assigned_user.id,
						complete_by: moment(this.campaign.complete_by),
						status: this.campaign.status,
						description: this.campaign.description,
						type: this.campaign.type,
					};
				}
			},

			mockCampaignCompleted() {
				this.campaign.status = 2;
				this.campaign.status_text = 'Complete';
				this.campaign.ended_on = moment();
				Swal.fire({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    icon: 'success',
                    title: 'Campaign complete!',
                });	
			},

			mockCampaignStarted() {
				this.campaign.status = 1;
				this.campaign.status_text = 'In progress';
				this.campaign.started_on = moment();
			},

            setLayout() {
				if (this.config.layout === 'mobile') {
					this.showCampaignDetails = false;
				} else {
					this.showCampaignDetails = true;
				}            	
            },

			showCheckin(checkin_id) {
				this.$root.$emit('show_checkin', checkin_id);
			},

			toggleAddVisits() {
				this.showAddVisits = !this.showAddVisits;
			},

			toggleCampaignDetails() {
				this.showCampaignDetails = !this.showCampaignDetails;
			},

			toggleTimestamps() {
				this.showTimestamps = !this.showTimestamps;
			},	

			updateCampaign() {
				axios.patch(`/api/campaigns/${this.campaign.id}`, this.form ).then(({data}) => {
					this.campaign = data;
	                this.editing = false;	

					Swal.fire({
	                    toast: true,
	                    position: 'top-end',
	                    showConfirmButton: false,
	                    timer: 3000,
	                    icon: 'success',
	                    title: 'Campaign updated',
	                });	
	                this.$store.dispatch('refreshCampaigns');		
				});
			},
		},

		computed: {
			...mapGetters(['allProviderIds']),
			...mapState(['config', 'options', 'perms']),

			campaignProgress() {
				if (this.data_loaded) {
					var count = 0;
					this.campaign.visits.forEach(visit => {
						if(visit.checkin_id) {
							count++;
						}
					});
					var progress = 100*(count / this.campaign.visits.length);
					progress = Math.round(progress);
					return progress;
				}
			},

			checkins() {
				if (this.data_loaded) {
					let checkins = [];
					this.campaign.visits.forEach(visit => {
						if (visit.checkin) {
							visit.checkin.checkinable = visit.visitable; 
							checkins.push(visit.checkin);
						}
					});
					return checkins;
				}
			},	

			nonCampaignPhysicians() {
				return this.allProviderIds.filter(physician => !this.campaign.visits.some(visit => (visit.visitable_id == physician.id && visit.visitable_type == 'App\\Physician')));

			}					
		},

		watch: {
			config: {
				handler() {
					this.setLayout();
				},
				deep: true,
			},

			'campaign.visits'() {
				//remove orphaned bulk IDs if visits change
				this.bulk_action_ids = this.bulk_action_ids.filter(item => this.campaign.visits.some(visit => (visit.visitable_id == item.morphable_id && visit.visitable_type == item.morphable_type)));
			},

			campaignProgress() {
				if (this.checkin_added && this.campaignProgress === 100 && this.campaign.status != 2) {
					this.mockCampaignCompleted();
				}

				if (this.campaignProgress < 100 && this.campaign.status == 2) {
					this.mockCampaignStarted();						
				}				
			}
		},
	}

</script>